import { useLoadingState } from "@/store";
import { Loader } from "./Loader"

export const GlobalLoader = () => {
  const { isLoading } = useLoadingState();

  return <Loader isLoading={isLoading} />;
}
